import { Button, Menu, MenuItem, MenuList, MenuPopover, MenuTrigger, Spinner, makeStyles, tokens } from '@fluentui/react-components';
import { AddRegular, ChevronDown16Regular } from '@fluentui/react-icons';

type CreateButtonProps = {
  /** When true, primary action is "New Workflow" (inside an app) */
  hasAppContext: boolean;
  onCreateWorkflow: () => void;
  onCreateApp: () => void;
  onCreateProject?: () => void;
  isCreating?: boolean;
};

const useStyles = makeStyles({
  container: {
    display: 'flex',
    alignItems: 'center',
  },
  primaryButton: {
    borderTopRightRadius: '0',
    borderBottomRightRadius: '0',
  },
  chevronButton: {
    borderTopLeftRadius: '0',
    borderBottomLeftRadius: '0',
    minWidth: 'auto',
    paddingLeft: tokens.spacingHorizontalXS,
    paddingRight: tokens.spacingHorizontalXS,
    borderLeftWidth: '1px',
    borderLeftStyle: 'solid',
    borderLeftColor: tokens.colorNeutralForegroundOnBrand,
  },
});

export const CreateButton = ({
  hasAppContext,
  onCreateWorkflow,
  onCreateApp,
  onCreateProject,
  isCreating,
}: CreateButtonProps) => {
  const styles = useStyles();

  const primaryLabel = hasAppContext ? 'New Workflow' : 'New App';
  const primaryAction = hasAppContext ? onCreateWorkflow : onCreateApp;

  const secondaryItems: Array<{ label: string; onClick: () => void }> = hasAppContext
    ? [
        { label: 'New App', onClick: onCreateApp },
        ...(onCreateProject ? [{ label: 'New Project', onClick: onCreateProject }] : []),
      ]
    : [
        { label: 'New Workflow', onClick: onCreateWorkflow },
        ...(onCreateProject ? [{ label: 'New Project', onClick: onCreateProject }] : []),
      ];

  return (
    <div className={styles.container}>
      <Button
        appearance="primary"
        className={styles.primaryButton}
        icon={isCreating ? <Spinner size="tiny" /> : <AddRegular />}
        onClick={primaryAction}
        disabled={isCreating === true}
      >
        {primaryLabel}
      </Button>
      <Menu>
        <MenuTrigger disableButtonEnhancement>
          <Button
            appearance="primary"
            className={styles.chevronButton}
            icon={<ChevronDown16Regular />}
            disabled={isCreating === true}
            aria-label="More create options"
          />
        </MenuTrigger>
        <MenuPopover>
          <MenuList>
            {secondaryItems.map((item) => (
              <MenuItem key={item.label} onClick={item.onClick}>
                {item.label}
              </MenuItem>
            ))}
          </MenuList>
        </MenuPopover>
      </Menu>
    </div>
  );
};
